import { Typography } from 'antd'
import React from 'react';
import {
    FilterOutlined,
    TableOutlined,
    PlaySquareOutlined
} from '@ant-design/icons';
import Legend from '../../../../components/Legend/Legend';
import { Trans, useTranslation } from 'react-i18next';

export default function HelpTab() {
    const { t } = useTranslation("history");

    return <>
        <Typography.Title level={4}>{t("ohjeitaOtsikko")}</Typography.Title>
        <p>
            {t("ohjeRivi1")}
        </p>
        <p>
            <Trans i18nKey="history:ohjeRivi2" components={{
                i: <PlaySquareOutlined />
            }}>
                Kartalle ilmestyy alueen valitsemisen jälkeen aikajana, josta voit valita haluamasi ajanhetken. Voit myös painaa toistonappulaa <PlaySquareOutlined />, jolloin aikajana siirtyy eteenpäin kuukauden kerrallaan itsekseen.
            </Trans>
        </p>
        <p>
            {t("ohjeRivi3")}
        </p>
        <p>
            <Trans i18nKey="history:ohjeRivi4" components={{
                i: <TableOutlined />
            }}>
                Listaan (valikossa kohta <TableOutlined />) ilmestyy metsänkäyttöilmoitusten pinta-ala per hakkuun toteuttamistapa sekä metsänkäyttöilmoituksissa ilmoitetun puuston iän keskiarvo. Huomaathan, että metsänkäyttöilmoituksissa ei ole
                aina ilmoitettu puuston ikää.
            </Trans>
        </p>
        <p>
            {t("ohjeRivi5")}
        </p>
        <p>
            <Trans i18nKey="history:ohjeRivi6" components={{
                i: <FilterOutlined />
            }}>
                Voit halutessasi valita, minkä tyyppiset metsänkäyttöilmoitukset otetaan huomioon, käyttämällä metsänkäyttöilmoitusten suodattimia (valikon kohta <FilterOutlined />).
            </Trans>
        </p>

        <Legend />
    </>
}